const React = require('react');
const noop = require('mn-utils/noop');

const withState = require('../../../../../../utils/withState');
const Ripple = require('../../../../../dumb/Ripple');

const Logo = require('../Logo');
const UserDisplay = require('../UserDisplay');

const Navigation = require('../Navigation/');

module.exports = withState((setState, self) => {
  self.state = {
    ...self.state,
    compactView: localStorage.getItem('f2c__compactMode') === 'true'
  };

  return (state, props) => {
    const compactView = state.compactView;
    return (
      <div className="abs s ov ovxA bgF ff$3 c0">
        <div className="rlv h">
          <div className={
            `w300 w68.compact w265@m w388@d3 abs svl ovx ovyA pr20`
            + (compactView ? ' compact' : '')
          }>
            <div
              className={
                `layoutRow fxdColumn bg3e4044 hmin pb30 pl30 pl0.compact pl15@m pl100@d3 bxsh12c0.7`
                + (compactView ? ' compact' : '')
              }
            >
              <Logo compactView={compactView} />
              <Navigation compactView={compactView} />
              <div className="mtAuto">
                <Ripple
                  className={
                    `h52 layoutRow aiC dn
                    (dB|dn)>.icon
                    (dB|ml8|f18|fw3|cA3A7AC|lh16)>.text
                    (jcC).compact
                    (rz).compact>.icon
                    (dN).compact>.text
                    (o70):h:not[.active]`
                    + (compactView ? ' compact' : '')
                  }
                  onClick={() => {
                    const nextVal = !compactView;
                    setState({compactView: nextVal});
                    localStorage.setItem('f2c__compactMode', nextVal);
                  }}
                >
                  <div>
                    <svg className="icon" width="14" height="20" viewBox="0 0 14 20" fill="#A3A7AC" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M2.00007 1C2.00007 0.448 1.55207 0 1.00006 0C0.448063 0 6.10352e-05 0.448 6.10352e-05 1V19C6.10352e-05 19.552 0.448063 20 1.00006 20C1.55207 20 2.00007 19.552 2.00007 19V1ZM12.307 9H10.171C9.72498 9 9.50198 8.461 9.81698 8.146L11.5 6.46387C11.891 6.07387 11.891 5.4398 11.5 5.0498C11.11 4.6598 10.477 4.6598 10.086 5.0498L6.54897 8.58691C5.76896 9.36791 5.76896 10.6331 6.54897 11.4131C6.92297 11.7871 6.09298 10.9572 10.086 14.9502C10.476 15.3402 11.11 15.3402 11.5 14.9502C11.891 14.5592 11.891 13.9262 11.5 13.5352L9.81899 11.854C9.50399 11.539 9.727 11 10.173 11H12.307C12.86 11 13.307 10.552 13.307 10C13.307 9.448 12.86 9 12.307 9Z" />
                    </svg>
                  </div>
                  <span className="text">Compact view</span>
                </Ripple>
              </div>
            </div>
          </div>
          <div className={
            `admin-content abs sl300 sl265@m sl388@d3 (sl65-i).compact svr ovxA ovyS`
            + (compactView ? ' compact' : '')
          }>
            <div className="hmin pb60 ph30 ph15@m ph50@d2 pr100@d3 w ov">
              <div className="hmin rlv">
                <UserDisplay />
                <div className="ff$3 c0">
                  {props.children}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
});
